import React, { Component } from 'react';

class GeckoIcon extends Component {

    prepareClass() {
        return (this.props.icon || '').replace('fa-', '');
    }

    renderClass() {
        return `gecko-icon fa fa-${this.prepareClass()}`;
    }

    render() {
		return (
            <i className={this.renderClass()}></i>      
        );
    }
}

export default GeckoIcon;